import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getPublicPricingPageDetailsRpc } from '../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const rpcClientNoAuth = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const GET_PUBLIC_PRICING_PAGE_DETAILS = registerQuery({
  fieldName: 'publicPricingPageDetails',
  args: ['earlyRequestName', 'browserLocale', 'preferredCountryCode'],
  fetcher({
    earlyRequestName,
    browserLocale,
    preferredCountryCode
  }) {
    return getEarlyRequestResult(earlyRequestName, () => rpcClientNoAuth.call(getPublicPricingPageDetailsRpc, {
      request: {
        browserLocale,
        preferredCountryCode
      }
    }));
  }
});